import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustInspections: "DustInspection.DustInspections",
  list: "DustInspection.DustInspectionList",
  new: "DustInspection.DustInspectionNew",
  base: "DustInspection.DustInspectionBase",
  view: "DustInspection.DustInspectionView",
  edit: "DustInspection.DustInspectionEdit",
  complete: "DustInspection.DustInspectionComplete",
  recomplete: "DustInspection.DustInspectionRecomplete",
  approve: "DustInspection.DustInspectionApprove",
  reject: "DustInspection.DustInspectionReject",
  enforcementActions: "DustInspection.DustInspectionEnforcementActions",
  documents: "DustInspection.DustInspectionDocuments",
  documentsEdit: "DustInspection.DustInspectionDocumentsEdit",
  documentsNew: "DustInspection.DustInspectionDocumentsNew",
  inspectionNotes: "DustInspection.DustInspectionNotes",
  noteEdit: "DustInspection.DustInspectionNoteEdit",
  noteNew: "DustInspection.DustInspectionNoteNew",
  audit: "DustInspection.DustInspectionAudit",
};

export { names as dustInspectionRouteNames };

const dustInspectionRoutes: RouterOptions["routes"] = [
  {
    path: "/dustInspection",
    name: names.dustInspections,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Inspections",
          lookupGroups: ["ProgramType", "InspectionStatus", "InspectionType", "InspectionComplianceAction"],
        },
        component: () => import("@/views/dustInspections/DustInspectionList.vue"),
      },
      {
        path: "new/:constructionProjectId(\\d+)?",
        component: () => import("@/views/dustInspections/DustInspectionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Dust Inspection", isNew: true },
            component: () => import("@/views/dustInspections/DustInspectionEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/dustInspections/DustInspectionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Dust Inspection View" },
            component: () => import("@/views/dustInspections/DustInspectionView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Dust Inspection Edit", isForm: true },
            component: () => import("@/views/dustInspections/DustInspectionEdit.vue"),
          },
          {
            path: "complete",
            name: names.complete,
            meta: { title: "Complete Inspection", isForm: true },
            component: () => import("@/views/dustInspections/CompleteInspection.vue"),
          },
          {
            path: "recomplete",
            name: names.recomplete,
            meta: { title: "Recomplete Inspection", isForm: true },
            component: () => import("@/views/dustInspections/RecompleteInspection.vue"),
          },
          {
            path: "approve",
            name: names.approve,
            meta: { title: "Approve Inspection", isForm: true },
            component: () => import("@/views/dustInspections/ApproveInspection.vue"),
          },
          {
            path: "reject",
            name: names.reject,
            meta: { title: "Reject Inspection", isForm: true },
            component: () => import("@/views/dustInspections/RejectInspection.vue"),
          },
          {
            path: "enforcementActions",
            name: names.enforcementActions,
            meta: { title: "Dust Inspection Enforcement Actions" },
            component: () => import("@/views/dustInspections/EnforcementActionChildList.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Dust Inspection Documents" },
            component: {
              render: () => (
                <EntityDocuments idField="inspectionId" routeNamePrefix="DustInspection.DustInspectionDocuments" />
              ),
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Dust Inspection Document", isForm: true },
            component: () => import("@/views/dustInspections/DustInspectionDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Dust Inspection Documents", isForm: true },
            component: () => import("@/views/dustInspections/DustInspectionDocuments.vue"),
          },
          {
            path: "notes",
            name: names.inspectionNotes,
            meta: { title: "Dust Inspection Notes" },
            component: {
              render: () => <EntityNotes idField="inspectionId" routeNamePrefix="DustInspection.DustInspectionNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Dust Inspection Note", isForm: true },
            component: () => import("@/views/dustInspections/DustInspectionNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Dust Inspection Note", isForm: true },
            component: () => import("@/views/dustInspections/DustInspectionNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Dust Inspection Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="inspection" />,
            },
          },
        ],
      },
    ],
  },
];
export default dustInspectionRoutes;
